namespace h5_vm {
   class CloneVmToLibraryServiceFactory {
      public static $inject = [
         "cloneVmBasicInformationPageService",
         "cloneVmLocationPageService",
         "cloneVmLibraryItemPageService",
         "VmProvisioningComputeResourcePageService",
         "vmProvisioningDatastorePageService",
         "cloneVmReviewPageService"
      ];

      constructor(cloneVmBasicInformationPageService: any,
            cloneVmLocationPageService: any,
            cloneVmLibraryItemPageService: any,
            VmProvisioningComputeResourcePageService: any,
            vmProvisioningDatastorePageService: any,
            cloneVmReviewPageService: any) {
         return () => {
            return new CloneVmToLibraryService(
                  cloneVmBasicInformationPageService,
                  cloneVmLocationPageService,
                  cloneVmLibraryItemPageService,
                  VmProvisioningComputeResourcePageService,
                  vmProvisioningDatastorePageService,
                  cloneVmReviewPageService);
         };
      }
   }

   export class CloneVmToLibraryService {

      public static $inject = [
            "cloneVmBasicInformationPageService",
            "cloneVmLocationPageService",
            "cloneVmLibraryItemPageService",
            "VmProvisioningComputeResourcePageService",
            "vmProvisioningDatastorePageService",
            "cloneVmReviewPageService"
      ];

      constructor(
            private cloneVmBasicInformationPageService: any,
            private cloneVmLocationPageService: any,
            private cloneVmLibraryItemPageService: any,
            private VmProvisioningComputeResourcePageService: any,
            private vmProvisioningDatastorePageService: any,
            private cloneVmReviewPageService: any) { }

      buildPages(wizardScope: any, defaultTargetId: string,
                 preselectedComputeResourceId: string, preselectedStorageId: string): { pages: Array<any> } {

         let basicInformationPage: any = this.cloneVmBasicInformationPageService
               .build(wizardScope, defaultTargetId);
         let locationPage: any = this.cloneVmLocationPageService
               .build(wizardScope, defaultTargetId);
         let libraryItemPage: any = this.cloneVmLibraryItemPageService
             .build(wizardScope, defaultTargetId);
         let computeResourcePage: any = this.VmProvisioningComputeResourcePageService
             .build(wizardScope, preselectedComputeResourceId);
         let storagePage: any = this.vmProvisioningDatastorePageService
               .build(wizardScope, preselectedStorageId);
         let reviewPage: any = this.cloneVmReviewPageService
               .build(wizardScope, defaultTargetId);


         return {
            pages: [
                basicInformationPage,
                locationPage,
                libraryItemPage,
                computeResourcePage,
                storagePage,
                reviewPage
            ]
         };
      }
   }

   angular.module("com.vmware.vsphere.client.vm")
         .service("cloneVmToLibraryService",
               CloneVmToLibraryServiceFactory);
}
